import { useContext } from 'react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

export const useWorldReadyContext = () => useContext(WorldReadyContext)
